import Landing from '../components/LandingScreenComponents/Landing';
import SkinCarePlan from '../components/LandingScreenComponents/SkinCarePlan';
import Quiz from '../components/LandingScreenComponents/Quiz';
import RoutinePlan from '../components/LandingScreenComponents/RoutinePlan';
import Assistent from '../components/LandingScreenComponents/Assistent';
import ManageSkincare from '../components/LandingScreenComponents/ManageSkincare';
import Progress from '../components/LandingScreenComponents/Progress';
import Adv from '../components/LandingScreenComponents/Adv';
import AppStore from '../components/LandingScreenComponents/AppStore';
import Footer from '../components/LandingScreenComponents/Footer';
import { useEffect } from 'react';
import ReactGA from '../utils/googleAnalytics';



const HomeScreen = () => {
    

    useEffect(() => {
        if(process.env.NODE_ENV === "production"){
            ReactGA.event({
          category: "User",
          action: "first_open",
        });
        }
    }, [])
    return (

        <div>
        <Landing />
        <SkinCarePlan />
        <Quiz />
        <RoutinePlan />
        <Assistent />
        <ManageSkincare />
        <Progress />
        <Adv />
        <AppStore />
        <Footer />
        </div>

    )
};

export default HomeScreen;